import Vue from 'vue';
import Router from 'vue-router';
import agreementPages from './agreement';

Vue.use(Router);

// 测试环境或者开发环境才有的路由
let devRoutes = [];
if (process.env.VUE_APP_API === 'development') {
	devRoutes = [
		{
			path: '/test',
			name: 'test',
			desc: '功能测试页',
			component: () => import(/* webpackChunkName: "test" */ '../views/Test.vue'),
			meta: {
				title: '功能测试页'
			}
		}
	];
}

// 正式环境的路由
const prodRoutes = [
	{
		path: '/',
		name: 'home',
		desc: '首页',
		redirect: '/mindCourse'
	},
	{
		path: '/404',
		name: 'page404',
		desc: '404页',
		component: () => import(/* webpackChunkName: "page404" */ '../views/404.vue')
	},
	{
		path: '/login',
		name: 'login',
		desc: '登录页',
		component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
		meta: {
			title: '登录'
		}
	},
	{
		path: '/phoneLogin',
		name: 'phoneLogin',
		desc: '手机登录页',
		component: () => import(/* webpackChunkName: "phoneLogin" */ '../views/PhoneLogin.vue'),
		meta: {
			title: '手机登录'
		}
	},
	{
		path: '/mindCourse',
		name: 'mindCourse',
		desc: '思维训练课订购页',
		component: () => import(/* webpackPrefetch: true */ '../views/MindCourse.vue'),
		meta: {
			keepAlive: true,
			title: '脑力大冒险儿童智力开发'
		}
	},
	{
		path: '/mindCourseSuccess',
		name: 'mindCourseSuccess',
		desc: '思维训练课订购成功页',
		component: () => import(/* webpackChunkName: "mindCourseSuccess" */ '../views/MindCourseSuccess.vue')
	},
	{
		path: '/mindCourseOrder',
		name: 'mindCourseOrder',
		desc: '思维训练课订单确认页',
		component: () => import(/* webpackChunkName: "mindCourseOrder" */ '../views/MindCourseOrder.vue'),
		meta: {
			title: '订单确认'
		}
	},
	{
		path: '/addressEditor',
		name: 'addressEditor',
		desc: '地址编辑页',
		component: () => import(/* webpackChunkName: "addressEditor" */ '../views/AddressEditor.vue'),
		meta: {
			title: '地址编辑'
		}
	},
	...agreementPages,
	{
		path: '*',
		name: 'notFound',
		redirect: '404'
	}
];

// 合并路由
export const routes = devRoutes.concat(prodRoutes);

export default new Router({
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.meta && to.meta.backTop) {
			return { x: 0, y: 0 };
		}

		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	}
});
